export default "__VITE_ASSET__616217aa__"